import { render, staticRenderFns } from "./AssignmentReport.vue?vue&type=template&id=163b818e&scoped=true&"
import script from "./AssignmentReport.vue?vue&type=script&lang=js&"
export * from "./AssignmentReport.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentReport.vue?vue&type=style&index=0&id=163b818e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163b818e",
  null
  
)

export default component.exports